import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { generateClassNameForReverseType } from 'helpers/transactions'
import { formatLocalDateUTC } from 'utils/date'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

export const getTransactionsFundingSummaryDetailsColumns = (showBankName = false): GridColumn[] => {
  return transactionsFundingSummaryDetailsColumns.map((column) => {
    if (column.field === 'externalAccount.bankName') {
      return { ...column, show: showBankName }
    }
    return column
  })
}

export const transactionsFundingSummaryDetailsColumns: GridColumn[] = [
  {
    title: 'External Account',
    field: 'externalAccount.externalAccount',
    show: true,
    filter: 'text',
    width: 320,
    className: 'table-columns__content',
  },
  {
    title: 'Bank Name',
    field: 'externalAccount.bankName',
    show: false,
    filter: 'text',
    width: 120,
    className: 'table-columns__content',
  },
  {
    title: 'Amount',
    field: 'externalAccount.amount',
    show: true,
    filter: 'text',
    width: 100,
    className: 'table-columns__number',
  },
  {
    title: 'Currency',
    field: 'currency.id',
    show: true,
    filter: 'text',
    width: 100,
    className: 'table-columns__number',
  },
  {
    title: 'PSP Amount',
    field: 'externalAccount.paymentAmount',
    show: true,
    filter: 'text',
    width: 100,
    className: 'table-columns__number',
  },
  {
    title: 'PSP Currency',
    field: 'externalAccount.paymentCurrency.id',
    show: true,
    filter: 'text',
    width: 100,
    className: 'table-columns__number',
  },
  {
    title: 'Count',
    field: 'externalAccount.transactionCount',
    show: true,
    filter: 'text',
    width: 100,
    className: 'table-columns__number',
  },
  {
    title: 'Last Date',
    field: 'externalAccount.lastDate',
    cell: (gridCellProps: GridCellProps): JSX.Element => {
      if (!gridCellProps.dataItem?.lastDate) {
        return <td className={generateClassNameForReverseType(gridCellProps.dataItem)} />
      }
      return (
        <td className={generateClassNameForReverseType(gridCellProps.dataItem)}>
          {formatLocalDateUTC(gridCellProps.dataItem.externalAccount.lastDate, true)}
        </td>
      )
    },
    show: true,
    filter: 'text',
    width: 180,
    className: 'table-columns__date',
  },
]
